module.exports = __webpack_public_path__ + "img/Union.bd197328.svg";